module.exports = __webpack_public_path__ + "img/20.cecc5a26.png";